<template>

	<div :class="{'csv-imports': true, modal: true }">

		<div class="modal-wrap">

			<div class="modal-inner">

				<Loading v-if="loading!==''" position="inner" :text="loading" />

				<h2 class="modal-title">{{ showTitle }}<span class="close" @click="close">X</span></h2>

				<p v-if="error!==''" class="error-message" v-html="error" />

				<div class="modal-inner-scroll" v-if="report.items.length===0">

					<Table 
						:headings="tableHeadings" 
						:items="table.items" 
						:pages="table.pages"
						:page="table.page"
						:count="table.count"
						:loading="table.loading"
						:sorted="table.sorted"
						:key="'csv-1'"
						@pagination="pagination"
						loadingText="Loading CSVs..."
						emptyLabel="You haven't imported any CSVs into this project yet"
						:addNewButtonLabel="importButton"
						@addNew="uploadCSV"
						@processStatus="processStatus"
						@deleteCSV="deleteCSV"
					/>

					<div class="frequency-wrap" v-if="importButton">
						<label>Frequency (for new keywords)</label>
						<v-select 
				            v-model="frequency" 
				            :options="[{ _id: 'daily', label: 'Daily' },{ _id: 'weekly', label: 'Weekly' },{ _id: 'monthly', label: 'Monthly' }]" 
				            :reduce="option => option._id"
				            :append-to-body="true"
				        ></v-select>

				    </div>

				</div>
				<div class="modal-inner-scroll" v-if="report.items.length>0">

					<p class="message" v-html="report.message" v-if="report.message!==''" />

					<Table 
						:headings="tableHeadingsReport" 
						:items="report.items" 
						:pages="report.pages"
						:key="'csv-2'"
						:page="report.page"
						:count="report.count"
						:addNewButtonLabel="reportButton"
						@addNew="confirmCSV"
						@pagination="pagination"
					/>

				</div>

			</div>

		</div>

	</div>

</template>

<script>
import { mapMutations } from 'vuex'
import ApiService from './../services/api.service'
import Loading from './Loading.vue'
import Table from './Table.vue'
import TableButton from './Display/TableButton.vue'
export default {
	name: 'CSVImports',
	props: {
		project: Object
	},
	components: {
		Loading,
		Table,
		TableButton 
	},
	data() {

		return {
			frequency: 'daily',
			page: 1,
			table: {
				page: 1,
				sorted: { keyword: 1 },
				search: {},
				loading: true,
				items: []
			},
			timer: null,
			report: {
				page: 1,
				search: {},
				items: [],
				message: '',
				_id: null,
				needsConfirmation: false
			},
			loading: '',
			csvId:  null,
			error: "",
			deleting: false
		}

	},
	computed: { 

		importButton () {

			return this.project.canUploadCSV ? 'Import a new CSV' : null;

		},

		reportButton () {

			if ( this.report.needsConfirmation ) return 'Click to process successfull rows only';

			return null;

		},

		tableHeadingsReport () {

			return {
				line: { value: 'Row' },
				keyword: { value: 'Keyword' },
				issues: { value: 'Issues' }
			}

		},
		
		tableHeadings () {

			let h = {
				name: { value: 'File Name' },
				created: { value: 'Uploaded', dateFormat: 'jS M Y' },
				status: { value: 'Status', component: TableButton, event: 'processStatus' },
				delete: { value: '', component: TableButton, event: 'deleteCSV' }
			};

			return h;

		},

		queryString () {

			return '?page=' + this[this.tableType].page;

		},

		showTitle () {

			if ( this.report.items.length > 0 ) {

				return this.report.name + ' Errors';

			}

			return 'CSV Imports';

		},

		tableType () {

			return this.csvId !== null ? 'report' : 'table';

		}

    },
	methods: {

		...mapMutations('general',['updateLoadingText']),

		confirmCSV () {

			this.$dialog
				.confirm( "Are you sure?", { okText: 'Yes', cancelText: 'Cancel',})
				.then(function() {

					this.updateLoadingText("One moment..");

					ApiService.put( 'keywords/csv-confirm/' + this.report._id )
					.then( function( info ) {

						this.updateLoadingText();
						this.report.items = [];
						this.csvId = null;
						this.get ();

					}.bind(this))
					.catch( function(err) {

						this.updateLoadingText();

					}.bind(this));

				}.bind(this))
				.catch(function() {});

		},

		processStatus ( { _id, name, processing, confirmed } ) {

			this.get(_id);

		},

		deleteCSV ( { _id, name, confirmed, processing } ) {

			let msg = "Are you sure you want to delete "+name+"?";

			if ( confirmed ) msg += " This will remove any info that has been added.";

			this.$dialog
				.confirm( msg, { okText: 'Yes please', cancelText: 'Cancel',})
				.then(function() {

					this.updateLoadingText("Deleting " + name + ", one moment..");

					ApiService.delete( 'keywords/csv/' + _id )
					.then( function( info ) {

						this.updateLoadingText();
						this.get ();
						this.error = info.data;

					}.bind(this))
					.catch( function(err) {

						this.updateLoadingText();
						this.$snotify.error(err.response.data.error, "Delete " + name);

					}.bind(this));

				}.bind(this))
				.catch(function() {});

		},

		pagination(info) {

			this[this.tableType].page = info.page;
			this.get();

		},

		uploadCSV () {

			this.error = '';
			this.$emit('upload-csv');

		},

		get ( csvId ) {

			if ( typeof csvId !== 'undefined' && csvId !== null ) this.csvId = csvId; 

			let url = this.csvId !== null ? 'keywords/csv/'+this.csvId+'/report' + this.queryString : 'keywords/csv/'+this.project._id + this.queryString;

			this[this.tableType].loading = true;

			ApiService.get( url, null, 'csvImports' )
			.then( function( info ) {

				this[this.tableType] = info.data;

				this[this.tableType].loading = false;

				if ( typeof csvId === 'undefined' ) {

					if ( this.timer !== null ) { // already testing for delete

						if ( !info.data.deleting && !info.data.processing ) {

							if ( this.deleting ) {

								this.error = "Your CSV has been deleted :)";

							}

							this.$emit('refresh-project');
							clearInterval(this.timer);
							this.timer = null;

						}

					}
					else if ( info.data.deleting || info.data.processing ) {

						this.timer = setInterval(() => this.get(), 5000);
						this.deleting = info.data.deleting;

					}

				}

			}.bind(this))
			.catch( function(err) {

			}.bind(this));

		},
		close () {

			if ( this.timer !== null ) {

				clearInterval(this.timer);

			}

			this.$emit('close');

		}
	},
	mounted() {

		this.get ();

	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_settings.less';
.modal {

	.modal-inner {

		padding-bottom: 0;

		.message {
			margin:0;
			color: @formDefaultColour;
		}

		.error-message {

			background-color: @red;
			margin: 0;
			padding: 10px;
			text-align: left;
			color: #fff;
			border-radius: 5px;

		}

		.frequency-wrap {

			label {

				font-size: 12px;

			}

		}

	}

}
@media screen and (min-width: 620px) {
	.modal {

		.modal-inner {

			.frequency-wrap {

				position: absolute;
				bottom: 34px;

			}

		}

	}
}
@media screen and (min-width: 960px) {
	.modal {

		.modal-inner {

			.frequency-wrap {

				bottom: 22px;

			}

		}

	}
}
</style>